import Image from "next/image";

type ProductHeadingProps = {
	title: string;
	desc: string;
	image: string
};

export const ProductHeading = ({ title, desc, image }: ProductHeadingProps) => {
	return (
		<div className="mb-4 flex items-center gap-3">
			<div className="flex h-11 w-11 items-center justify-center overflow-hidden rounded bg-gray-200">
				<Image src={image} alt={`${title} logo`} width={100} height={100} className="w-full h-full" />
			</div>

			<div>
				<h3 className="mb-0.5 font-bold text-gray-900">{title}</h3>
				<p className="text-xs text-gray-500">{desc}</p>
			</div>
		</div>
	);
};
